import React, {useCallback, useEffect, useRef, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import {submitCashAtHand} from "../api/RestCallHelper";
import DatePicker from "../shared/DatePicker";
import TextInput from "../shared/TextInput";
import {validateForm} from "../utils/ValidationUtil";
import FormPage from "./baseFormPage/BaseFormPage";
import FormHeader from "../shared/FormHeader";
import {FormButton} from "../styles/globalStyles";
import {FeedbackReducerActionType, useFeedbackDispatch} from "../utils/FeedbackContext";
import ToggleButtonGroup from "../shared/ToggleButtonGroup";

export default () => {

    let location = useLocation();
    let history = useHistory();
    let dispatch = useFeedbackDispatch();

    const [cashAtHand, setCashAtHand] = useState({
        amount:"",
        flag:true,
        date: null,
        reason:"",
    });

    const [formValidated, setFormValidated] = useState(false);
    const [isSending, setIsSending] = useState(false);
    const isMounted = useRef(true);

    const clear = () => {
        setCashAtHand({
            amount:"",
            flag:true,
            date: null,
            reason:"",
            transactionType:""
        });
    }

    const close = (event, reason) => {
        console.log("In CashAtHand close callback");
        if (reason === 'clickaway') return;

        dispatch({type: FeedbackReducerActionType.CLOSE_FEEDBACK});
    };

    const submit = useCallback(async () => {

        // don't send again while we are sending
        if (isSending) return;

        // update state
        setIsSending(true);

        // send the actual request
        console.log("cashAtHand", cashAtHand);
        await submitCashAtHand(cashAtHand, dispatch, close, history, location);

        if (isMounted.current){
            //only update if we are still mounted
            setIsSending(false);
            clear()
        }

    }, [isSending, cashAtHand, location, isMounted]);

    useEffect(() => {
        setFormValidated(validateForm(cashAtHand));
        console.log("cashAtHand", cashAtHand);
    }, [cashAtHand, formValidated]);

    return (
        <FormPage

            header = {
                <FormHeader
                    heading="Cash At Hand"
                />
            }

            form = { 
                <>

                    <ToggleButtonGroup
                        value={cashAtHand.flag}
                        setValue= {(value) => (setCashAtHand({...cashAtHand,  flag: value}))}
                        trueOption="Deposit"
                        falseOption="Withdrawal"
                    />

                    <TextInput
                        number
                        label="Amount"
                        value={cashAtHand.amount}
                        onChange={(value) => setCashAtHand({ ...cashAtHand, amount: value }) }
                        style={{ margin: "10px" }}
                    />

                    <TextInput
                        multiline
                        label="Reason"
                        value={cashAtHand.reason}
                        onChange={(value) => setCashAtHand({ ...cashAtHand, reason: value }) }
                        style={{ margin: "10px" }}
                    />

                    <DatePicker
                        label="Date"
                        value={cashAtHand.date}
                        onChange={(value) => setCashAtHand({ ...cashAtHand, date: value }) }
                        style={{ margin: "10px" }}
                    />
                </>
            }

            buttons = {
                <>
                    {formValidated &&
                        <FormButton
                            disabled={isSending}
                            onClick={submit}
                        >
                            Submit
                        </FormButton>   
                    }
    
                    <FormButton
                        onClick={clear}
                        disabled={isSending}
                    >
                        Clear
                    </FormButton>
                </>
            }

        />
    );
}